import { Button, Loading, Modal, Notification } from "@quark/design";
import { FC, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getExamDetail } from "../../../../api";
import { ExamDetail, ExamLog } from "../../../../types/exam";
import { logUsedTime } from "../../utils";
import styles from "./index.module.scss";

interface LogListModalProps {
  visible: boolean;
  examId: number;
  onClose: () => void;
}

const LogListModal: FC<LogListModalProps> = ({ visible, examId, onClose }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [exam, setExam] = useState<ExamDetail>();
  const logs = useMemo(() => {
    // 最多展示5次
    return (exam?.logs || []).slice(0, 5);
  }, [exam]);

  const showResult = (log: ExamLog) => {
    navigate(`/exam/${exam?.id}/${log.id}`);
    onClose();
  };

  useEffect(() => {
    if (visible) {
      setLoading(true);
      getExamDetail(examId)
        .then((res) => {
          setExam(res);
          if (!res.logs.length) {
            Notification.error("暂无做题记录", { duration: 2000 });
            onClose();
          }
        })
        .catch(() => {
          alert("获取试题信息失败!");
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [visible, examId, onClose]);

  return (
    <Modal
      contentClassName={styles.content}
      title="最近做题记录"
      visible={visible}
      onClose={onClose}
    >
      {loading ? (
        <Loading />
      ) : (
        <div>
          <div>{exam?.title}</div>
          {logs.map((log) => {
            const logFinished = !!log.end_time;
            return (
              <div className={styles.card} key={log.id}>
                <div className={styles.title}>{log.start_time}</div>
                <div className={styles.line}>
                  <div>
                    <span className={styles.label}>总题数:</span>
                    <span className={styles.value}>{log.quiz_num}</span>
                  </div>
                  <div>
                    <span className={styles.label}>正确数:</span>
                    <span className={styles.value}>{log.right_num}</span>
                  </div>
                  <div>
                    <span className={styles.label}>错题数:</span>
                    <span className={styles.value}>{log.wrong_num}</span>
                  </div>
                  <div>
                    <span className={styles.label}>正确率:</span>
                    <span className={styles.value}>
                      {Math.floor((log.right_num / (log.quiz_num || 1)) * 100)}%
                    </span>
                  </div>
                </div>

                <div className={styles.line}>
                  <div>
                    <span className={styles.label}>耗时:</span>
                    <span className={styles.value}>{logUsedTime(log)}</span>
                  </div>

                  {logFinished && (
                    <Button onClick={() => showResult(log)}>查看结果</Button>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </Modal>
  );
};

export default LogListModal;
